import { atom } from "jotai";
import {
	PORTFOLIO_SORT,
	type PortfolioSortKey,
} from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioSortKey";
import type { PortfolioCategoryId } from "web_myplann/Portfolio/Types/portfolioCategory";

export type PortfolioFilterState = {
	categories: PortfolioCategoryId[];
	sort: PortfolioSortKey;
	sortDesc: boolean;
};

export const defaultPortfolioFilterState: PortfolioFilterState = {
	categories: [],
	sort: PORTFOLIO_SORT.oblast,
	sortDesc: false,
};

export const isDefaultPortfolioFilter = (
	state: PortfolioFilterState,
): boolean =>
	state.sort === defaultPortfolioFilterState.sort &&
	state.sortDesc === defaultPortfolioFilterState.sortDesc &&
	state.categories.length === 0;

export const portfolioFilterState = atom<PortfolioFilterState>(
	defaultPortfolioFilterState,
);
